import I18n from "i18n-js";
import {Button} from "@mui/material";
import TelegramIcon from '@mui/icons-material/Telegram';

export interface TelegramShareProps {
  url: string;
  text?: string;
}
export default function TelegramShare({url, text}: TelegramShareProps) {
  const shareUrl = `https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(I18n.t("SocialShare.telegram.shareText"))}`;
  if (!text) {
    text = I18n.t("SocialShare.telegram.defaultText");
  }

  return (
    <Button
      startIcon={<TelegramIcon />}
      fullWidth={false}
      href={shareUrl}
      target="_blank"
      sx={{
        color: "#FFFFFF",
        backgroundColor: "#0088cc",
        lineHeight: "1",
        width: "auto",
        marginRight: "5px",
        ":hover": {
          backgroundColor: "#0077b3",
        }
      }}
    >
      {text}
    </Button>
  );
}